module.exports = __webpack_public_path__ + "media/images/linked-in-bd8403cb56c209b65140518e141b0a5b.svg";